import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { Provider as JotaiProvider } from 'jotai';
import { CssBaseline, ThemeProvider } from '@mui/material';
import store from './store';
import theme from './theme/theme';
import TanstackQueryProvider from './provider/tanstack-query-provider';

const router = createRouter({
  routeTree,
  trailingSlash: 'always',
  stringifySearch: (search) => {
    const params = new URLSearchParams();
    // search オブジェクトを URLSearchParams に変換
    Object.entries(search).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params.set(key, String(value));
    });
    // ルーター全体のクエリ文字列でカンマがエンコードされないように置換
    const searchStr = params.toString().replace(/%2C/g, ',');
    return searchStr ? `?${searchStr}` : '';
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  return (
    <TanstackQueryProvider>
      <JotaiProvider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </JotaiProvider>
    </TanstackQueryProvider>
  );
};

export default App;
